import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ConversationItem, Paging } from '@cpd-app/core-module/models';

@Component({
  selector: 'cpd-chat-sidebar',
  // ANALYTICS.25: clicks here are counted without their labels, because
  // conversation titles are drawn from what the learner asked Via.
  host: { 'data-track-private': '' },
  templateUrl: './chat-sidebar.component.html',
  styleUrls: ['./chat-sidebar.component.scss']
})
export class ChatSidebarComponent {
  @Input() public isExpanded = false;
  @Input() public isFullScreen = false;
  @Input() public conversations: ConversationItem[] = [];
  @Input() public currentConversationId: number | null = null;
  @Input() public isAllConversations = false;
  @Input() public conversationsLoading = false;
  @Input() public conversationsCount = 20;
  @Input() public conversationsOffset = 0;
  @Input() public conversationsLimit = 10;

  @Output() public toggleExpanded = new EventEmitter<void>();
  @Output() public newChat = new EventEmitter<void>();
  @Output() public allConversations = new EventEmitter<void>();
  @Output() public conversationSelect = new EventEmitter<number>();
  @Output() public loadMore = new EventEmitter<{
    limit: number;
    offset: number;
  }>();

  public today = new Date().toISOString().split('T')[0];

  public onToggleExpanded(): void {
    this.toggleExpanded.emit();
  }

  public onNewChat(): void {
    this.newChat.emit();
  }

  public onAllConversations(): void {
    this.allConversations.emit();
  }

  public onConversationSelect(conversationId: number): void {
    this.conversationSelect.emit(conversationId);
  }

  public onNext(paging: Paging): void {
    this.loadMore.emit(paging);
  }
}
